import React, { useState } from 'react';
import { Button } from './ui/button';
import { ArrowRight, Zap } from 'lucide-react';
import RequestAccessModal from './RequestAccessModal';

const Hero = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleLogin = () => {
    window.location.href = 'https://app.alpenglowstudio.net';
  };

  const handleRequestAccess = () => {
    setIsModalOpen(true);
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-[#0a2e2e] via-[#1a4d4d] to-[#0f3a3a]">
      {/* Animated Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-[#8b956d]/5 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-[#8b956d]/5 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 text-center">
        {/* Logo */}
        <div className="flex justify-center mb-12 animate-fadeIn">
          <img
            src="https://customer-assets.emergentagent.com/job_excalibur-login/artifacts/geb8n6q4_WEBHeader.png"
            alt="Excalibur Logo"
            className="h-48 w-auto md:h-56 lg:h-64 drop-shadow-2xl transition-transform duration-500 hover:scale-110"
          />
        </div>

        {/* Tagline */}
        <div className="mb-8 animate-fadeIn" style={{ animationDelay: '0.2s' }}>
          <p className="text-xl md:text-2xl lg:text-3xl text-[#c5c9b8] font-semibold mb-4 drop-shadow-lg" style={{ textShadow: '0 2px 10px rgba(0,0,0,0.5)' }}>
            The Legendary CRM Platform
          </p>
          <p className="text-lg md:text-xl text-[#c5c9b8]/90 max-w-3xl mx-auto leading-relaxed drop-shadow-md">
            Wield the power of all-in-one marketing automation, CRM, and client management. Built on GoHighLevel, forged for excellence.
          </p>
        </div>

        {/* Features Badge */}
        <div className="flex flex-wrap justify-center gap-4 mb-12 animate-fadeIn" style={{ animationDelay: '0.4s' }}>
          <div className="flex items-center space-x-2 bg-[#8b956d]/10 backdrop-blur-sm px-4 py-2 rounded-full border border-[#8b956d]/30">
            <Zap className="w-4 h-4 text-[#8b956d]" />
            <span className="text-[#c5c9b8] text-sm font-medium">Unlimited Contacts</span>
          </div>
          <div className="flex items-center space-x-2 bg-[#8b956d]/10 backdrop-blur-sm px-4 py-2 rounded-full border border-[#8b956d]/30">
            <Zap className="w-4 h-4 text-[#8b956d]" />
            <span className="text-[#c5c9b8] text-sm font-medium">AI-Powered Automation</span>
          </div>
          <div className="flex items-center space-x-2 bg-[#8b956d]/10 backdrop-blur-sm px-4 py-2 rounded-full border border-[#8b956d]/30">
            <Zap className="w-4 h-4 text-[#8b956d]" />
            <span className="text-[#c5c9b8] text-sm font-medium">Multi-Channel Campaigns</span>
          </div>
          <div className="flex items-center space-x-2 bg-[#8b956d]/10 backdrop-blur-sm px-4 py-2 rounded-full border border-[#8b956d]/30">
            <Zap className="w-4 h-4 text-[#8b956d]" />
            <span className="text-[#c5c9b8] text-sm font-medium">Full Time Pro Support</span>
          </div>
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-fadeIn" style={{ animationDelay: '0.6s' }}>
          <Button
            onClick={handleLogin}
            size="lg"
            className="bg-[#8b956d] hover:bg-[#9ca878] text-[#0a2e2e] font-bold text-lg px-8 py-6 rounded-lg transition-all duration-300 hover:shadow-2xl hover:shadow-[#8b956d]/40 hover:scale-105 group"
          >
            Access Your CRM
            <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" />
          </Button>
          <Button
            onClick={handleRequestAccess}
            size="lg"
            variant="outline"
            className="border-2 border-[#8b956d] text-[#c5c9b8] hover:bg-[#8b956d]/10 font-semibold text-lg px-8 py-6 rounded-lg transition-all duration-300 hover:shadow-lg hover:scale-105"
          >
            Request Access
          </Button>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
          <div className="w-6 h-10 border-2 border-[#8b956d]/50 rounded-full flex items-start justify-center p-2">
            <div className="w-1 h-3 bg-[#8b956d]/50 rounded-full"></div>
          </div>
        </div>
      </div>

      {/* Request Access Modal */}
      <RequestAccessModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </section>
  );
};

export default Hero;
